import { jsx as _jsx } from "react/jsx-runtime";
import { EventBus } from '@catawiki/runtime-toolkit';
import { Button } from '@catawiki/cata-style';
export const SignInLink = ({ label }) => {
    const handleOnClick = (event) => {
        event.preventDefault();
        EventBus.showScreen({
            screen: EventBus.Screen.SIGN_IN,
        });
    };
    return (_jsx(Button, { variant: "tertiary", onClick: handleOnClick, color: "info", children: label }));
};
//# sourceMappingURL=SignInLink.js.map